import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'letrus-ui';
import {useNavigate} from 'react-router-dom';
import styles from './OptionalRewriteModal.module.scss';

export interface OptionalRewriteModalProps {
  id: string;
  onClose(): void;
}

function OptionalRewriteModal({id, onClose}: OptionalRewriteModalProps) {
  const navigate = useNavigate();

  function handleDoRewrite() {
    onClose();
  }

  function handleGoBack() {
    onClose();
    navigate(-1);
  }

  return (
    <Modal id={id} closeButton onClick={onClose}>
      <article className={styles.wrapper}>
        <span>
          <FontAwesomeIcon
            icon={['far', 'circle-star']}
            size="2x"
            color="#2a5082"
          />
        </span>

        <h1 className={styles.title}>Esta é uma etapa opcional!</h1>

        <p className={styles.description}>
          A reescrita desta trilha é opcional. Você pode realizá-la para
          melhorar sua nota, mas não é obrigatório. Em caso de dúvidas, entre em
          contato com o seu professor.
        </p>

        <div className={styles.footer}>
          <Button variant="primary" onClick={handleDoRewrite}>
            Fazer a reescrita
          </Button>

          <Button variant="secondary" onClick={handleGoBack}>
            Voltar
          </Button>
        </div>
      </article>
    </Modal>
  );
}

export default OptionalRewriteModal;
